import React from 'react';
import contentResolver from '../Utilities/EpiContentResolver';
import { EpiContext } from '../Store/EpiContext/Types';

export interface RadioButtonValgModel<T> {
    id: string;
    value: string;
    tekst: keyof T;
}

export function RadioButtonValg<T>(
    group: string,
    id: string,
    value: string,
    tekst: keyof T,
    isChecked: boolean,
    epiContext: EpiContext<T>,
): JSX.Element {
    return (
        <div className="c-radio-input" key={id}>
            <input
                type="radio"
                name={group}
                value={value}
                id={id}
                checked={isChecked}
                aria-checked={isChecked}
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                onChange={(): void => {}} // Nødvendig pga. react setter den som read only hvis denne mangler
            />
            <label htmlFor={id}>{contentResolver(epiContext, tekst)}</label>
        </div>
    );
}
